export const privacy = {
  backToHome: "Back to home",
  title: "Privacy Policy",
  lastUpdated: "Last updated:",
  sections: {
    introduction: {
      title: "1. Introduction",
      content: "NovaVenture Group BV (hereinafter: 'NovaVenture', 'we' or 'us') respects your privacy and is committed to protecting personal data in accordance with the General Data Protection Regulation (GDPR) and Belgian legislation. This privacy policy explains how we collect, use and protect business data in the context of our B2B activities."
    },
    company: {
      title: "2. Data Controller",
      content: "NovaVenture Group BV",
      address: "Krommestraat 48, 2830 Blaasveld, Belgium",
      vat: "VAT number: BE1006303437",
      enterprise: "Enterprise number: 1006303437",
      email: "Email: David@novaventure.be",
      phone: "Phone: +32 488 13 96 64"
    },
    dataCollection: {
      title: "3. What Data Do We Process?",
      intro: "NovaVenture processes exclusively business data that is publicly available. We do NOT process personal data of natural persons, such as individual names, personal email addresses or other sensitive personal data.",
      subtitle: "The following business data is processed:",
      items: {
        company: "Company name (official trade name)",
        phone: "Fixed telephone number of the company",
        address: "Complete business address (street, number, postal code, municipality)",
        vat: "VAT number of the company"
      },
      note: "This data concerns exclusively legal entities (companies) and not natural persons in a private context."
    },
    dataSource: {
      title: "4. Source of Data",
      content: "All business data is collected from publicly accessible online sources where companies have published their information themselves, such as:",
      sources: [
        "Official business and trade registers",
        "Public websites of companies",
        "Public business directories",
        "Other legal, publicly accessible sources"
      ],
      note: "We do not purchase private databases and do not process data from non-public sources."
    },
    dataUsage: {
      title: "5. Purposes of Data Processing",
      intro: "We process business data for the following purposes:",
      items: [
        "B2B prospecting and business lead generation",
        "Commercial sale of business data to business customers",
        "Provision of business market information",
        "Support of legitimate business activities of our customers"
      ]
    },
    legalBasis: {
      title: "6. Legal Basis",
      intro: "The processing of business data is based on Article 6(1)(f) GDPR: legitimate interest.",
      content: "NovaVenture has a legitimate interest in collecting and providing publicly available business data for legitimate B2B activities. We have conducted a careful balancing of interests:",
      balancing: {
        title: "Balancing of interests:",
        business: "Business interest: Facilitating efficient B2B communication and market functioning",
        privacy: "Privacy impact: Minimal, as only publicly available business data of legal entities is processed",
        noPersonal: "No processing of personal data of natural persons in a private context",
        objection: "Companies have the right to object to inclusion in our database at any time"
      }
    },
    retention: {
      title: "7. Retention Period",
      content: "Business data is not retained longer than necessary for the purposes for which it was collected. We conduct periodic checks to ensure the accuracy and relevance of the data. Outdated or incorrect data is deleted or updated."
    },
    dataSharing: {
      title: "8. Disclosure to Third Parties",
      intro: "Business data is disclosed to:",
      items: [
        "Business customers who use the data for legitimate B2B prospecting",
        "Service providers who support us (e.g. hosting, IT security), under strict confidentiality obligations"
      ],
      euOnly: "We do not process data outside the European Union. All data processing takes place within the EU/EEA."
    },
    yourRights: {
      title: "9. Your Rights as a Data Subject",
      intro: "If your company is included in our database, you have the following rights:",
      items: {
        access: "Right of access: You can request which business data we process about your company",
        rectification: "Right to rectification: You can request correction of incorrect or outdated data",
        erasure: "Right to erasure: You can request deletion of your company's data",
        restriction: "Right to restriction: You can request restriction of processing",
        objection: "Right to object: You can object at any time to the processing of your company's business data"
      },
      objectionNote: {
        title: "Explicit right to object:",
        content: "Companies can object at any time to inclusion in our database. Upon receipt of your objection, we will delete your business data from our systems, unless we have demonstrable compelling legitimate grounds for processing that outweigh your interests."
      },
      howTo: {
        title: "How can you exercise your rights?",
        content: "You can exercise your rights by sending a request to:",
        email: "Email: David@novaventure.be",
        response: "We will process your request within 30 days and inform you of the measures taken."
      }
    },
    dataSecurity: {
      title: "10. Data Security",
      content: "NovaVenture takes appropriate technical and organizational measures to protect business data against unauthorized access, loss, misuse, alteration or disclosure. These measures include:",
      measures: [
        "Secure storage and encryption of data",
        "Access control and authentication",
        "Regular security updates and monitoring",
        "Confidentiality obligations for employees and processors"
      ]
    },
    complaint: {
      title: "11. Right to Lodge a Complaint",
      content: "If you believe that we are not processing your data correctly, you have the right to lodge a complaint with the Belgian supervisory authority:",
      authority: "Data Protection Authority (DPA)",
      addressLine1: "Drukpersstraat 35, 1000 Brussels, Belgium",
      phone: "Phone: +32 2 274 48 00",
      email: "Email: contact@apd-gba.be",
      website: "Website: www.dataprotectionauthority.be"
    },
    changes: {
      title: "12. Changes to This Privacy Policy",
      content: "NovaVenture reserves the right to modify this privacy policy. Changes will be published on this page with an updated date. We recommend that you consult this policy regularly."
    },
    contact: {
      title: "13. Contact",
      intro: "For questions about this privacy policy or to exercise your rights, you can contact us:",
      company: "NovaVenture Group BV",
      address: "Krommestraat 48, 2830 Blaasveld, Belgium",
      phone: "Phone:",
      email: "Email:",
      vat: "VAT: BE1006303437"
    }
  }
};